<template>
  <div>
    <sc-dropdown
      class="card-dropdown"
      aria-role="list"
      position="is-bottom-left"
    >

      <button
        v-if="this.app.status !== 'UNINSTALLED' && this.app.status !== 'MANUALLY_INSTALLED'"
        type="button" 
        class="card-menu-button" 
        slot="trigger">
        <sc-icon icon="ellipsis-v"></sc-icon>
      </button>

      <sc-dropdown-item
        class="card-dropdown-item"
        :id="`uninstall-item-${this.app.id}`"
        @click="onClickUninstall"
      >
        <sc-icon icon="times-circle" pack="far"></sc-icon> <span class="item-label">Desinstalar transportadora</span>
      </sc-dropdown-item>

    </sc-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScIcon,
  ScDropdown,
  ScDropdownItem,
  ScToast,
  ScDialog,
} from '@intelipost-js/secure-components';

const { mapActions } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);
export default {
  name: 'integrations-self-service-app-card-header-menu',
  components: {
    ScButton,
    ScIcon,
    ScDropdown,
    ScDropdownItem,
    ScToast,
    ScDialog,
  },
  data() {
    return {
    };
  },
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions([
      'uninstallSelfService',
      'getAppSelfServiceListApps',
    ]),

    onClickUninstall() {
      return ScDialog.confirm({
        title: 'Desinstalar transportadora',
        message: `Você tem certeza que deseja desinstalar a transportadora <b>${this.app.app_name}</b>?
          <section class="integrations-dialog-warning">
            <div class="integrations-warning-icon">
              <i class="fas fa-info-circle"></i>
            </div>
            <div>
              Caso opte por desinstalar, você pode reinstalar a qualquer momento.
            </div>
          </section>`,
        hasIcon: false,
        cancelText: 'Voltar',
        confirmText: 'Desinstalar',
        onConfirm: () =>
          this.uninstallSelfService(
            this.app.installation_id,
          ).then(({ ok, message }) => {
            if (!ok) {
              return ScToast.open({ message, duration: 20000, type: 'is-danger' });
            }

            this.getAppSelfServiceListApps();
            this.$root.$emit('clean-search');
            return ScToast.open({
              message: 'Transportadora desinstalada com sucesso',
              duration: 5000,
              type: 'is-success',
            });
          }),
      });
    },

  },
};
</script>

<style lang='scss' scoped>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.card-header-button {
  background: none;
  border: none;
}

.card-menu-button {
  border: none;
  background-color: white;
  margin: 1rem 0 0 0;
}

.card-dropdown-item {
  display: flex;
  align-items: center;

  .item-label {
    margin-left: 3px;
    margin-top: 1px;
  }
}
</style>
<style lang='scss'>

.integrations-dialog-warning {
  margin-top: 10px;
  padding: 8px;

  display: flex;
  align-items: baseline;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  border-color: #3670D6;
}

.integrations-warning-icon {
  margin: 5px;
  color: #3670D6;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/app-card/header-card/menu-card/MenuCard.vue?2940cd5a